import ServicoAPI from "../../../servicos/ServicoAPI.js"

/** Recálculo do trecho atual via OSRM `/route` da Mapp (mesmo endpoint das cotações). */
export async function calcularRotaAteProximo(dados, origem, destino) {
	if (!dados?.idProf || !dados?.token || !origem || !destino) return []
	const res = await ServicoAPI.calcularRotaCotacao(dados, {
		pontos: [
			{ la: origem.la, lo: origem.lo },
			{ la: destino.la, lo: destino.lo },
		],
		tipoVeiculo: dados.siglaTipoVeiculo || dados.tipoVeiculo || "M",
	})
	if (!res?.resultado || !Array.isArray(res?.dados?.polyline)) return []
	return res.dados.polyline.filter(
		(pt) => Array.isArray(pt) && pt.length >= 2 && Number.isFinite(Number(pt[0])) && Number.isFinite(Number(pt[1]))
	)
}
